import React from 'react';
import { Layout } from '../../components/layout/Layout';
import { PageHero, ContentSection, SEOContent, CTASection } from '../../components/shared';

export const ImpfungenPage = () => {
  return (
    <Layout>
      <PageHero
        title="Impfungen & Beratung: Ihr Schutz für ein gesundes Leben"
        subtitle="Wir beraten Sie umfassend zu Impfungen und schützen Sie und Ihre Familie vor Infektionskrankheiten."
        backgroundImage="/images/Content_Behandlung_6.webp"
        ctaText="Impf-Termin vereinbaren"
      />

      <ContentSection
        title="Sicherheit durch Impfschutz"
        content="Ob Standardimpfungen, Auffrischungen oder Reiseimpfungen – wir bieten Ihnen eine individuelle Beratung basierend auf Ihrem Alter, Ihrer Krankengeschichte und Ihren persönlichen Bedürfnissen. Wir informieren Sie über empfohlene Impfungen, mögliche Nebenwirkungen und den optimalen Impfzeitpunkt, um Ihren Schutz sicherzustellen."
        image="/images/Content_Behandlung_6.webp"
        backgroundColor="white"
      />

      <SEOContent
        title="Impfberatung und Impfungen in Diez"
        content="Die Gemeinschaftspraxis Dres. von Bergh in Diez bietet professionelle Beratung und Durchführung aller gängigen Impfungen zum Schutz Ihrer Gesundheit."
      />

      <CTASection
        title="Sind Ihre Impfungen aktuell?"
        subtitle="Lassen Sie uns gemeinsam Ihren Impfstatus überprüfen und planen Sie die notwendigen Impfungen."
        buttonText="Beratungstermin vereinbaren"
      />
    </Layout>
  );
};

export default ImpfungenPage;
